import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getTimeEntryArchiveForDatatableAsync, resetSelectedRecordObjectInState, deleteAccountEmployeeTimeEntryAsync,setSearchValue,setPageSizeValue,updatePagination } from "./TimeEntryArchiveSlice";
import TimeEntryArchiveItem from "./TimeEntryArchiveItem";
import moment from "moment";
import TimeEntryArchiveOffCanvas from "./TimeEntryArchiveOffCanvas"; 
import { TimeEntryArchiveForm } from "./TimeEntryArchiveForm";
import OffCanvas from '../../../common/OffCanvas';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import CustomPagination from "../../../common/Pagination";
import Select, { StylesConfig } from 'react-select';
import { useDebounce } from "../../../_metronic/helpers";
import { getPageSizeArray,sortData } from '../../../common/timeLiveFunction';
import { getFilteredList, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';


const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

const TimeEntryArchive = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const offCanvasList = [
        {
            name:
            getValueFromResource("Filters",dispatch,t) ,
            width: "500px",
            componentName: <TimeEntryArchiveOffCanvas t={t} />
        },
        {
            name: getValueFromResource("Update Time Entry Archive",dispatch, t),
            width: "200px",
            componentName: <TimeEntryArchiveForm />
        }
    ];
    const { timeEntryArchiveList, isReload, isLoading, currentPage,sortOrder, sortColumn, pageNo, pageSize, start, search, timeEntryArchiveCheckedIds, selectedRecord,
        optionClientNameValue, optionClientNameText, optionEmployeeNameValue, optionEmployeeNameText, optionProjectValue, optionProjectText,
        optionProjectTaskValue, optionProjectTaskText, optionApprovedValue, optionApprovedText, startDate, endDate, totalItems,optionTimeEntryValue
    } = useAppSelector((state) => state.timeEntryArchive);
    const [showOffCanvas, setShowOffCanvas] = useState(false);
    const [selectedOffCanvas, setSelectedOffCanvas] = useState(offCanvasList[0]); // Store the selected OffCanvas object
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const modelRef = useRef<any>(null);
    // const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();

   

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const debouncedSearchTerm = useDebounce(search, 300);

    useEffect(() => {
        const start =  1 * pageSize;
        let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${optionTimeEntryValue},${false},
        ${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
        dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: 1, pageSize: pageSize, start: 0, SearchParamsValues: SearchParamsValues, search: debouncedSearchTerm }));
    }, [debouncedSearchTerm, isReload]);
    
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

const handleOnClickEvent = () => {
    ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
        .then((result) => {
            if (result) {
                dispatch(deleteAccountEmployeeTimeEntryAsync(timeEntryArchiveCheckedIds))
                    .unwrap()
                    .then((originalPromiseResult) => {                       
                        const responseText = typeof originalPromiseResult === 'string' 
                            ? originalPromiseResult.trim() 
                            : JSON.stringify(originalPromiseResult) || '';

                        if (responseText.includes("Deleted Succesfully") || responseText.includes("Deleted Successfully")) {
                            return ShowToast("Time Entry(s) Deleted Successfully", 'Success', "success", "toast-top-right");
                        }

                        if (responseText.includes("<exceptionmessage>") || responseText.toLowerCase().includes("dependent data")) {
                            let cleanErrorMessage = "Can't delete: Dependent data exists with this record.";
                            
                           
                            const match = responseText.match(/<exceptionmessage>([\s\S]*?)<\/exceptionmessage>/i);
                            if (match && match[1]) {
                                cleanErrorMessage = match[1].replace("can't delete, ", "Cannot delete: ");
                            }
                            
                            return ShowToast('Error', cleanErrorMessage, "error", "toast-top-right");
                        }                     
                        if (responseText.length > 0 && !responseText.includes("{")) {
                            return ShowToast('Error', originalPromiseResult, "error", "toast-top-right");
                        }

                        ShowToast('Error', "Failed to delete records.", "error", "toast-top-right");
                    })
                    .catch((rejectedValueOrSerializedError) => {
                                               
                        let catchError = "An error occurred while deleting the record.";
                        if (typeof rejectedValueOrSerializedError === 'string') {
                            catchError = rejectedValueOrSerializedError;
                        } else if (rejectedValueOrSerializedError && typeof rejectedValueOrSerializedError === 'object') {
                            catchError = rejectedValueOrSerializedError.message || JSON.stringify(rejectedValueOrSerializedError);
                        }

                        if (catchError.toLowerCase().includes("dependent data") || catchError.includes("<exceptionmessage>")) {
                            catchError = "Can't delete: Dependent data exists with this record.";
                        }

                        ShowToast('Error', catchError, "error", "toast-top-right");
                    });
            }
        })
        .catch((error) => {
            console.error('Confirmation modal error:', error);
        });
};

    const handleFilterOnClickEvent = (selectedObject:any) => {
        setSelectedOffCanvas(selectedObject);
        setShowOffCanvas(true);
    }

    const handleFormOnClickEvent = (selectedObject:any) => {   
        setSelectedOffCanvas(selectedObject);
        setShowOffCanvas(true);
    }

    const handlePageChange = (pageNumber: any) => {
        // const start = (pageNumber - 1) * pageSize;
        // let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${false},
        //     ${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
        // dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: pageNumber, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: search }));
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
    //    let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${false},
    //         ${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
    //     dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: pageNumber, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: search }));
    let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${optionTimeEntryValue},${false},
            ${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
        dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: pageNumber, pageSize: pageSize, start: (pageNumber - 1) * Number(pageSize), SearchParamsValues: SearchParamsValues, search: search }));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(setSearchValue(value));
       
    };
    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        dispatch(setPageSizeValue(Number(value)));
        // const start =  1 * Number(value);

        // const filteredData: any = getFilteredList(timeEntryArchiveList, searchTerm);


        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
       let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${optionTimeEntryValue},${false},
       ${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
        dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: 1, pageSize: Number(value), start: 0, SearchParamsValues: SearchParamsValues, search: search }));
    };
    const filteredData: any = getFilteredList(timeEntryArchiveList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = timeEntryArchiveList.length;
    const recordsFiltered = filteredData.length;

    

    return (
        <>
{isLoading && <Loader />} 
            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle">
                        {/* {t('Time Entry Archive')} */}
                        {getValueFromResource('Time Entry Archive',dispatch, t)}
                        </h3>
                    <div className="card-toolbar align-items-center">
                        {/* {(timeEntryArchiveList.length > 0 && pageSize < totalItems) &&
                            <> */}
                                <div className="position-relative">
                            <input

                                value={search}
                                onChange={(e: any) => handleSearch(e)}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                                    <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </div>
                                <div className='h-35px w-1px mx-1'></div>
                                <div className="d-flex align-items-center">
                                {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                                /> */}
                                 <PageSizeSelect onChange={handlePageSizeChange} />

                                </div>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    {(currentItems.length > 0 ) ? (
                                        // <CustomPagination
                                        // currentPage={pageNo}
                                        //     onPageChange={handlePageChange}
                                        //     pageSize={pageSize}
                                        //     totalItems={totalItems}
                                        //     // start={start}
                                        //     start={(pageNo - 1) * pageSize}
                                        //     recordsFiltered={recordsFiltered}
                                        //     t={t}
                                        // >
                                        <CustomPagination
                                        currentPage={currentPage}
                                            onPageChange={handlePageChange}
                                            pageSize={pageSize}
                                            totalItems={totalItems}
                                             start={start}
                                            // start={(pageNo - 1) * pageSize}
                                            // recordsFiltered={recordsFiltered}
                                            t={t}
                                        >

                                        </CustomPagination>
                                    ) : null}
                                </div>
                            {/* </>
                        } */}
                        {(currentItems.length > 0) &&
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        }

                        {IsDelete &&
                            <button type="button" className="btn  btn-danger btn-bs-btn-font-weight btn-sm"
                                disabled={timeEntryArchiveCheckedIds.length === 0 ? true : false}
                                onClick={handleOnClickEvent}>
                                {/* {t('Delete')} */}
                                {getValueFromResource('Delete',dispatch, t)}
                            </button>
                        }
                        {IsList &&
                            <>
                                &nbsp;
                                <button
                                    id="kt_OffCanvas"
                                    type="button"
                                    className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                    onClick={() => handleFilterOnClickEvent(offCanvasList[0])}
                                >
                                    {/* {t('Filters')} */}
                                    {getValueFromResource('Filters',dispatch, t)}
                                </button>
                            </>
                        }
                    </div>
                </div>
                {IsList &&
                    // <div className="card-body">
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <TimeEntryArchiveItem  timeEntryArchiveList={currentItems}  onhandleFormOnClickEvent={handleFormOnClickEvent}  offCanvasObject={offCanvasList[1]}  t={t} onopenModal={openModal} IsEdit={IsEdit} IsDelete={IsDelete}
                            />
                        </div>
                    </div>
                }
            </div>
            <OffCanvas
                isOpen={showOffCanvas}
                onClose={() => setShowOffCanvas(false)}
                obj={selectedOffCanvas}
            />
            
            {isModalOpen &&
                <TimeEntryArchiveForm modelRef={modelRef} t={t} oncloseModal={closeModal} />
            }
        </>
    )
}

export default TimeEntryArchive;


// import React, { useEffect, useRef, useState } from "react";
// import { useAppSelector, useAppDispatch } from "../../../app/hooks"
// import { getTimeEntryArchiveForDatatableAsync, resetSelectedRecordObjectInState, deleteAccountEmployeeTimeEntryAsync } from "./TimeEntryArchiveSlice";
// import TimeEntryArchiveItem from "./TimeEntryArchiveItem";
// import moment from "moment";
// import TimeEntryArchiveOffCanvas from "./TimeEntryArchiveOffCanvas"; 
// import { TimeEntryArchiveForm } from "./TimeEntryArchiveForm";



// const TimeEntryArchive = () => {

//     const dispatch = useAppDispatch();
//     const modelRef = useRef<any>(null);
//     const retryRef = useRef<any>(null);
//     const { timeEntryArchiveList, isReload, currentPage, pageSize, totalItems, start, search, recordsFiltered,timeEntryArchiveCheckedIds } = useAppSelector((state) => state.timeEntryArchive);
//     const totalPages = Math.ceil(totalItems / pageSize);

//     const [dateRange, setDateRange] = useState({
//         startDate: new Date(),
//         endDate: new Date(),
//     });

//     // const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ [object: string]: any }>({ value: 'All', label: 'All' });
//     // const optionValue = selectedOptionDropDown ? selectedOptionDropDown.value : '';
//     // const [selectedWebhookEventOptionDropDown, setSelectedWebhookEventOptionDropDown] = useState<{ [object: string]: any }>({ value: 'All', label: 'All' });
//     // const optionWebhookValue = selectedWebhookEventOptionDropDown ? selectedWebhookEventOptionDropDown.value : '';

    
//     const [selectedClientNameOptionDropDown, setSelectedClientNameOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
//     const optionClientNameValue = selectedClientNameOptionDropDown ? selectedClientNameOptionDropDown.value : '0';
//     const optionClientNameText = selectedClientNameOptionDropDown ? selectedClientNameOptionDropDown.label : 'All';
    
//     const [selectedEmployeeNameOptionDropDown, setSelectedEmployeeNameOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
//     const optionEmployeeNameValue = selectedEmployeeNameOptionDropDown ? selectedEmployeeNameOptionDropDown.value : '0';
//     const optionEmployeeNameText = selectedEmployeeNameOptionDropDown ? selectedEmployeeNameOptionDropDown.label : 'All';

//     const [selectedProjectOptionDropDown, setSelectedProjectOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
//     const optionProjectValue = selectedProjectOptionDropDown ? selectedProjectOptionDropDown.value : '0';
//     const optionProjectText = selectedProjectOptionDropDown ? selectedProjectOptionDropDown.label : 'All';
    
//     const [selectedProjectTaskOptionDropDown, setSelectedProjectTaskOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
//     const optionProjectTaskValue = selectedProjectTaskOptionDropDown ? selectedProjectTaskOptionDropDown.value : '0';
//     const optionProjectTaskText = selectedProjectTaskOptionDropDown ? selectedProjectTaskOptionDropDown.label : 'All';
    
//     const [selectedApprovedOptionDropDown, setSelectedApprovedOptionDropDown] = useState<{ [object: string]: any }>({ value: '-1', label: 'Both' });
//     const optionApprovedValue = selectedApprovedOptionDropDown ? selectedApprovedOptionDropDown.value : '-1';
//     const optionApprovedText = selectedApprovedOptionDropDown ? selectedApprovedOptionDropDown.label : 'Both';

//     const handleDateRangeChange = (startDate: any, endDate: any) => {
//         setDateRange({
//             startDate: startDate,
//             endDate: endDate,
//         });
//     };
//     const handleClientNameChange = (data: any) => {
//         const { value, label } = data;
//         setSelectedClientNameOptionDropDown({ value: value, label: label });
//     };
//     const handleEmployeeNameChange = (data: any) => {
//         const { value, label } = data;
//         setSelectedEmployeeNameOptionDropDown({ value: value, label: label });
//     };
//     const handleProjectChange = (data: any) => {
//         const { value, label } = data;
//         setSelectedProjectOptionDropDown({ value: value, label: label });
//     };
//     const handleProjectTaskChange = (data: any) => {
//         const { value, label } = data;
//         setSelectedProjectTaskOptionDropDown({ value: value, label: label });
//     };
//     const handleApprovedChange = (data: any) => {
//         const { value, label } = data;
//         setSelectedApprovedOptionDropDown({ value: value, label: label });
//     };
//     const handleResetFiltersOnClickEvent = () => {
//         // console.log('handleResetFiltersOnClickEvent');
//         setSelectedClientNameOptionDropDown({ value: '0', label: 'All' });
//         setSelectedEmployeeNameOptionDropDown({ value: '0', label: 'All' });
//         setSelectedProjectOptionDropDown({ value: '0', label: 'All' });
//         setSelectedProjectTaskOptionDropDown({ value: '0', label: 'All' });
//         setSelectedApprovedOptionDropDown({ value: '-1', label: 'All' });
//         setDateRange({
//             startDate: new Date(),
//             endDate: new Date()
//         });
//         dispatch(resetSelectedRecordObjectInState());
//     }
//     const isGuid = (stringToTest: any) => {
//         if (stringToTest[0] === "{") {
//             stringToTest = stringToTest.substring(1, stringToTest.length - 1);
//         }
//         var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
//         var x = regexGuid.test(stringToTest);
//         return x;
//     };
//     useEffect(() => {
//         if (isReload) {
//             let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${false},
//             ${moment(dateRange.startDate).format('MM-DD-YYYY')},${moment(dateRange.endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
//             // let SearchParamsValues = `${0},${0},${0},${0},${-1},${false},${moment().subtract(7, 'days').format('MM-DD-YYYY')},${moment(dateRange.endDate).format('MM-DD-YYYY')},${'All'},${'All'},${'All'},${'All'}`;
//             dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: currentPage, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: " " }));
//         }
//     }, [isReload]);
//     useEffect(() => {
//         let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${false},
//         ${moment(dateRange.startDate).format('MM-DD-YYYY')},${moment(dateRange.endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
//         dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: currentPage, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues , search: " "}));
//     }, [dispatch]);

//     const handlePageChange = (pageNumber: any) => {
//         const start = (pageNumber - 1) * pageSize;
//         let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${false},
//         ${moment(dateRange.startDate).format('MM-DD-YYYY')},${moment(dateRange.endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
//         dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: pageNumber, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: search }));
//     };
//     // const [isFilterOpen, setIsFilterOpen] = useState(false);
//     const handleOnClickEvent = () => {
//         //const commaSeparatedString = ''//WebHookReceiverLogCheckedIds.join(', ');
//         const result = window.confirm('Are you sure you want to delete?');
//         if (result) {
//             dispatch(deleteAccountEmployeeTimeEntryAsync(timeEntryArchiveCheckedIds));
//           //console.log('Confirmed!');
//         } else {
//           // User clicked "Cancel," handle accordingly (optional)
//           console.log('Cancelled!');
//         }
        
//     };
//     const handleApplyFilterOnClickEvent = () => {
//         dispatch(resetSelectedRecordObjectInState());
//         let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${false},
//         ${moment(dateRange.startDate).format('MM-DD-YYYY')},${moment(dateRange.endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
//         dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: 1, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: search }));
//     }

//     // const [selectedRows, setSelectedRows] = useState([]);
//     // const [selectAll, setSelectAll] = useState(false);
//     const handleSearch = (event:any) => {
//         console.log(event.target.value);
//         dispatch(resetSelectedRecordObjectInState());
//         let SearchParamsValues = `${optionClientNameValue},${optionEmployeeNameValue},${optionProjectValue},${optionProjectTaskValue},${optionApprovedValue},${false},
//         ${moment(dateRange.startDate).format('MM-DD-YYYY')},${moment(dateRange.endDate).format('MM-DD-YYYY')},${optionClientNameText},${optionEmployeeNameText},${optionProjectText},${optionProjectTaskText}`;
//         dispatch(getTimeEntryArchiveForDatatableAsync({ currentPage: 1, pageSize: pageSize, start: start, SearchParamsValues: SearchParamsValues, search: event.target.value }));
//     };
   
//     return (
//         <>
//             <TimeEntryArchiveOffCanvas
//                 onDateRangeChange={handleDateRangeChange}
//                 onhandleClientNameChange={handleClientNameChange}
//                 onhandleEmployeeNameChange={handleEmployeeNameChange}
//                 onhandleProjectChange={handleProjectChange}
//                 onhandleProjectTaskChange={handleProjectTaskChange}
//                 onhandleApprovedChange={handleApprovedChange}
//                 onhandleApplyFilterOnClickEvent={handleApplyFilterOnClickEvent}
//                 onhandleResetFiltersOnClickEvent={handleResetFiltersOnClickEvent}
//             ></TimeEntryArchiveOffCanvas>

//             <div className="card card-custom">
//                 <div className="card-header">
//                     <h3 className="card-title">Time Entry Archive</h3>
//                     <div className="card-toolbar">
//                         <button ref={retryRef} type="button" className="btn btn-sm btn-danger"
//                             disabled={timeEntryArchiveCheckedIds.length === 0 ? true : false}
//                             onClick={handleOnClickEvent}>
//                             Delete
//                         </button>
//                         <button id="kt_OffCanvas" className="btn bg-light-primary text-primary">
//                             <i className="ki-outline ki-plus fs-5 text-primary "></i>
//                             Filter
//                         </button>
//                     </div>
//                 </div>
//                 <div className="card-body">

//                     <div className="table-responsive">
//                     {/* <input type="text" className="form-control" style={{width:'200px'}} onChange={(event)=>handleSearch(event)} placeholder="Search" /> */}
//                     <TimeEntryArchiveItem timeEntryArchiveList={timeEntryArchiveList} onhandlePageChange={handlePageChange} modelRef={modelRef} />
//                     </div>
//                 </div>
//             </div>
//             <TimeEntryArchiveForm modelRef={modelRef} />
//             <button ref={modelRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#timeEntryArchiveModal">
//                 Launch demo modal
//             </button>
//         </>
//     )
// }

// export default TimeEntryArchive;